import React, { useState } from "react";
import ViewIcon from "../../utils/assets/view.svg";
import HideIcon from "../../utils/assets/hide.svg";
import { Link, useNavigate } from "react-router-dom";
import {validateFields} from '../../validations/auth-validation'
import { ValidateSignUP } from '../../actions/auth'
import { toast } from "react-toastify";

const SignUp = () => {
  const initialState = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  };
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: ""
  })
  const [errorMsg, setErrorMsg] = useState(initialState);

  const [passwordIcon, setPasswordIcon] = useState("password");
  console.log("userData", userData);
  console.log("passwordIcon", passwordIcon);
  const navigate = useNavigate();
  console.log("err", errorMsg);
  const isEmpty = (obj) => Object.keys(obj).length === 0;


    async function checkFields(e) {
      e.preventDefault();
      const errors = validateFields(userData);
      setErrorMsg(errors);
      if (isEmpty(errors)) {
        await ValidateSignUP(userData, navigate).then((res) => {
          if (res.data.success == true) {
              // Save token to localStorage
            localStorage.setItem('token', res?.data?.token);
            localStorage.setItem('userType', res?.data?.data?.type);
            toast.success("User has been created successfully")
            if (res?.data?.data?.type === 'user') {
              navigate('/client');
            } else if (res?.data?.data?.type === 'admin') {
              navigate('/admin');
            }
          }else{
            toast.error("Something went wrong")
          }
        });
      }
    }
  

  return (
    <>
    <div className="hide-on-sm bg-light min-vh-100">
      <div className="container">
        <div className="row h-vh d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
            <form
            onSubmit={checkFields}
              style={{ borderRadius: "20px" }}
              className="card bg-white shadow d-flex justify-content-center text-start align-items-start p-5"
            >
              <h3 className="text-black txt-head">Mac Repair Specialist</h3>
              <p className="txt-secondary txt-p text-wrap">
                Welcome to Mac Repair Specialist, where your devices come back
                to life. Sign Up to get started.
              </p>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  Name
                </label>
                <input type="text" required value={userData.name} onChange={(e) => {
                  setUserData({...userData, name: e.target.value})
                }} className="form-control" />
                {
                  errorMsg.name && <span className="text-danger txt-err m-1">{errorMsg.name}</span>
                }
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  Email
                </label>
                <input type="email" required value={userData.email} onChange={(e) => {
                  setUserData({...userData, email: e.target.value})
                }} className="form-control" />
                {
                  errorMsg.email && <span className="text-danger txt-err m-1">{errorMsg.email}</span>
                }
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  password
                </label>
                <div className="input-group">
                  <input type={passwordIcon} required value={userData.password} onChange={(e) => {
                    setUserData({...userData, password: e.target.value})
                  }} className="form-control" />
                  {passwordIcon === "text" ? (
                    <span
                      onClick={() => setPasswordIcon("password")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={HideIcon} alt="password" />
                    </span>
                  ) : (
                    <span
                      onClick={() => setPasswordIcon("text")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={ViewIcon} alt="password" />
                    </span>
                  )}
                  
                </div>
                {
                  errorMsg.password && <span className="text-danger txt-err m-1">{errorMsg.password}</span>
                }
              </div>
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="btn bg-black text-white mt-5 w-75">Submit</button>
              </div>
              <div className=" w-100 justify-content-center align-items-center mt-3 text-center">
                <span className="my-1 txt-p txt-secondary">Already have an Account? <Link to="/sign-in" className="txt-secondary">Sign In</Link> </span>              
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div className="hide-on-lg bg-light">
    <div className="container">
        <div className="row h-vh d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
            <form onSubmit={checkFields}
              className="justify-content-center text-start align-items-start p-4"
            >
              <h3 className="text-black txt-head">Mac Repair Specialist</h3>
              <p className="txt-secondary txt-p text-wrap">
                Welcome to Mac Repair Specialist, <br /> Sign up to get started.
              </p>
              <div className="w-100 mt-4">
                <label htmlFor="" className="form-label text-black">
                  Name
                </label>
                <input type="text" className="form-control" required value={userData.name} onChange={(e) => {
                  setUserData({...userData, name: e.target.value})
                }} />
                {
                  errorMsg.name && <span className="text-danger txt-err m-1">{errorMsg.name}</span>
                }
              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  Email
                </label>
                <input type="email" required value={userData.email} onChange={(e) => {
                  setUserData({...userData, email: e.target.value})
                }} className="form-control" />
                {
                 errorMsg.email && <span className="text-danger txt-err m-1">{errorMsg.email}</span>
                }

              </div>
              <div className="w-100 mt-2">
                <label htmlFor="" className="form-label text-black">
                  password
                </label>
                <div className="input-group">
                  <input type={passwordIcon} minLength={8} required value={userData.password} onChange={(e) => {
                    setUserData({...userData, password: e.target.value})
                  }} className="form-control" />
                  {passwordIcon === "text" ? (
                    <span
                      onClick={() => setPasswordIcon("password")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={HideIcon} alt="password" />
                    </span>
                  ) : (
                    <span
                      onClick={() => setPasswordIcon("text")}
                      className="input-group-text"
                      id="basic-addon1"
                    >
                      {" "}
                      <img width={20} src={ViewIcon} alt="password" />
                    </span>
                  )}
                  {
                  errorMsg.password && <span className="text-danger txt-err m-1">{errorMsg.password}</span>
                  }
                </div>
              </div>
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="btn bg-black mt-5 w-100">Submit</button>
              </div>
              <div className=" w-100 justify-content-center align-items-center mt-3 text-center">
                <span className="my-1 txt-p txt-secondary">Already have an account? <Link to="/sign-in" className="txt-secondary">Sign in</Link> </span>              
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default SignUp;
